import { TagColor, TagColumn } from '../../types/responsiveTable';

export interface TagFilterOption {
  label: string;
  value: any;
  color: TagColor;
}

export const getTagFilterOptions = <T extends Record<string, any>>(data: T[], column: TagColumn<T>): TagFilterOption[] => {
  const optionsMap = new Map<string, TagFilterOption>();

  data.forEach((row) => {
    const value = column.textKeyFromCallBack ? column.textKeyFromCallBack(row[column.accessor], row) : row[column.accessor];
    if (value && value !== '-') {
      optionsMap.set(value, {
        value,
        label: value,
        color: column.colorFromCallBack(row[column.accessor], row),
      });
    }
  });

  return Array.from(optionsMap.values()).sort((a, b) => a.label.localeCompare(b.label));
};
